const CountryCodes = [
  { label: "中国", label_en: "China", value: "+86" },
  { label: "中国香港", label_en: "Hong Kong", value: "+852" },
  { label: "中国澳门", label_en: "Macau", value: "+853" },
  { label: "中国台湾", label_en: "Taiwan", value: "+886" },
  { label: "美国", label_en: "United States", value: "+1" },
  { label: "英国", label_en: "United Kingdom", value: "+44" },
  { label: "日本", label_en: "Japan", value: "+81" },
  { label: "韩国", label_en: "South Korea", value: "+82" },
  { label: "德国", label_en: "Germany", value: "+49" },
  { label: "法国", label_en: "France", value: "+33" },
  { label: "俄罗斯", label_en: "Russia", value: "+7" },
  { label: "加拿大", label_en: "Canada", value: "+1" },
  { label: "澳大利亚", label_en: "Australia", value: "+61" },
  { label: "新加坡", label_en: "Singapore", value: "+65" },
  { label: "印度", label_en: "India", value: "+91" },
  { label: "巴西", label_en: "Brazil", value: "+55" },
  { label: "南非", label_en: "South Africa", value: "+27" },
  { label: "埃及", label_en: "Egypt", value: "+20" },
  { label: "沙特阿拉伯", label_en: "Saudi Arabia", value: "+966" },
  { label: "阿联酋", label_en: "United Arab Emirates", value: "+971" },
  { label: "阿富汗", label_en: "Afghanistan", value: "+93" },
  { label: "阿尔巴尼亚", label_en: "Albania", value: "+355" },
  { label: "阿尔及利亚", label_en: "Algeria", value: "+213" },
  { label: "安道尔", label_en: "Andorra", value: "+376" },
  { label: "安哥拉", label_en: "Angola", value: "+244" },
  { label: "阿根廷", label_en: "Argentina", value: "+54" },
  { label: "亚美尼亚", label_en: "Armenia", value: "+374" },
  { label: "奥地利", label_en: "Austria", value: "+43" },
  { label: "阿塞拜疆", label_en: "Azerbaijan", value: "+994" },
  { label: "巴哈马", label_en: "Bahamas", value: "+1242" },
  { label: "巴林", label_en: "Bahrain", value: "+973" },
  { label: "孟加拉国", label_en: "Bangladesh", value: "+880" },
  { label: "巴巴多斯", label_en: "Barbados", value: "+1246" },
  { label: "白俄罗斯", label_en: "Belarus", value: "+375" },
  { label: "比利时", label_en: "Belgium", value: "+32" },
  { label: "伯利兹", label_en: "Belize", value: "+501" },
  { label: "贝宁", label_en: "Benin", value: "+229" },
  { label: "不丹", label_en: "Bhutan", value: "+975" },
  { label: "玻利维亚", label_en: "Bolivia", value: "+591" },
  {
    label: "波斯尼亚和黑塞哥维那",
    label_en: "Bosnia and Herzegovina",
    value: "+387",
  },
  { label: "博茨瓦纳", label_en: "Botswana", value: "+267" },
  { label: "文莱", label_en: "Brunei", value: "+673" },
  { label: "保加利亚", label_en: "Bulgaria", value: "+359" },
  { label: "布基纳法索", label_en: "Burkina Faso", value: "+226" },
  { label: "布隆迪", label_en: "Burundi", value: "+257" },
  { label: "柬埔寨", label_en: "Cambodia", value: "+855" },
  { label: "喀麦隆", label_en: "Cameroon", value: "+237" },
  { label: "佛得角", label_en: "Cape Verde", value: "+238" },
  {
    label: "中非共和国",
    label_en: "Central African Republic",
    value: "+236",
  },
  { label: "乍得", label_en: "Chad", value: "+235" },
  { label: "智利", label_en: "Chile", value: "+56" },
  { label: "哥伦比亚", label_en: "Colombia", value: "+57" },
  { label: "科摩罗", label_en: "Comoros", value: "+269" },
  { label: "刚果(布)", label_en: "Congo (Brazzaville)", value: "+242" },
  { label: "刚果(金)", label_en: "Congo (Kinshasa)", value: "+243" },
  { label: "哥斯达黎加", label_en: "Costa Rica", value: "+506" },
  { label: "科特迪瓦", label_en: "Côte d'Ivoire", value: "+225" },
  { label: "克罗地亚", label_en: "Croatia", value: "+385" },
  { label: "古巴", label_en: "Cuba", value: "+53" },
  { label: "塞浦路斯", label_en: "Cyprus", value: "+357" },
  { label: "捷克", label_en: "Czech Republic", value: "+420" },
  { label: "丹麦", label_en: "Denmark", value: "+45" },
  { label: "吉布提", label_en: "Djibouti", value: "+253" },
  { label: "多米尼克", label_en: "Dominica", value: "+1767" },
  { label: "多米尼加", label_en: "Dominican Republic", value: "+1809" },
  { label: "厄瓜多尔", label_en: "Ecuador", value: "+593" },
  { label: "萨尔瓦多", label_en: "El Salvador", value: "+503" },
  { label: "赤道几内亚", label_en: "Equatorial Guinea", value: "+240" },
  { label: "厄立特里亚", label_en: "Eritrea", value: "+291" },
  { label: "爱沙尼亚", label_en: "Estonia", value: "+372" },
  { label: "埃塞俄比亚", label_en: "Ethiopia", value: "+251" },
  { label: "斐济", label_en: "Fiji", value: "+679" },
  { label: "芬兰", label_en: "Finland", value: "+358" },
  { label: "加蓬", label_en: "Gabon", value: "+241" },
  { label: "冈比亚", label_en: "Gambia", value: "+220" },
  { label: "格鲁吉亚", label_en: "Georgia", value: "+995" },
  { label: "加纳", label_en: "Ghana", value: "+233" },
  { label: "希腊", label_en: "Greece", value: "+30" },
  { label: "格林纳达", label_en: "Grenada", value: "+1473" },
  { label: "危地马拉", label_en: "Guatemala", value: "+502" },
  { label: "几内亚", label_en: "Guinea", value: "+224" },
  { label: "几内亚比绍", label_en: "Guinea-Bissau", value: "+245" },
  { label: "圭亚那", label_en: "Guyana", value: "+592" },
  { label: "海地", label_en: "Haiti", value: "+509" },
  { label: "洪都拉斯", label_en: "Honduras", value: "+504" },
  { label: "匈牙利", label_en: "Hungary", value: "+36" },
  { label: "冰岛", label_en: "Iceland", value: "+354" },
  { label: "印度尼西亚", label_en: "Indonesia", value: "+62" },
  { label: "伊朗", label_en: "Iran", value: "+98" },
  { label: "伊拉克", label_en: "Iraq", value: "+964" },
  { label: "爱尔兰", label_en: "Ireland", value: "+353" },
  { label: "以色列", label_en: "Israel", value: "+972" },
  { label: "意大利", label_en: "Italy", value: "+39" },
  { label: "牙买加", label_en: "Jamaica", value: "+1876" },
  { label: "约旦", label_en: "Jordan", value: "+962" },
  { label: "哈萨克斯坦", label_en: "Kazakhstan", value: "+7" },
  { label: "肯尼亚", label_en: "Kenya", value: "+254" },
  { label: "基里巴斯", label_en: "Kiribati", value: "+686" },
  { label: "科威特", label_en: "Kuwait", value: "+965" },
  { label: "吉尔吉斯斯坦", label_en: "Kyrgyzstan", value: "+996" },
  { label: "老挝", label_en: "Laos", value: "+856" },
  { label: "拉脱维亚", label_en: "Latvia", value: "+371" },
  { label: "黎巴嫩", label_en: "Lebanon", value: "+961" },
  { label: "莱索托", label_en: "Lesotho", value: "+266" },
  { label: "利比里亚", label_en: "Liberia", value: "+231" },
  { label: "利比亚", label_en: "Libya", value: "+218" },
  { label: "列支敦士登", label_en: "Liechtenstein", value: "+423" },
  { label: "立陶宛", label_en: "Lithuania", value: "+370" },
  { label: "卢森堡", label_en: "Luxembourg", value: "+352" },
  { label: "马达加斯加", label_en: "Madagascar", value: "+261" },
  { label: "马拉维", label_en: "Malawi", value: "+265" },
  { label: "马来西亚", label_en: "Malaysia", value: "+60" },
  { label: "马尔代夫", label_en: "Maldives", value: "+960" },
  { label: "马里", label_en: "Mali", value: "+223" },
  { label: "马耳他", label_en: "Malta", value: "+356" },
  { label: "马绍尔群岛", label_en: "Marshall Islands", value: "+692" },
  { label: "毛里塔尼亚", label_en: "Mauritania", value: "+222" },
  { label: "毛里求斯", label_en: "Mauritius", value: "+230" },
  { label: "墨西哥", label_en: "Mexico", value: "+52" },
  { label: "密克罗尼西亚", label_en: "Micronesia", value: "+691" },
  { label: "摩尔多瓦", label_en: "Moldova", value: "+373" },
  { label: "摩纳哥", label_en: "Monaco", value: "+377" },
  { label: "蒙古", label_en: "Mongolia", value: "+976" },
  { label: "黑山", label_en: "Montenegro", value: "+382" },
  { label: "摩洛哥", label_en: "Morocco", value: "+212" },
  { label: "莫桑比克", label_en: "Mozambique", value: "+258" },
  { label: "缅甸", label_en: "Myanmar", value: "+95" },
  { label: "纳米比亚", label_en: "Namibia", value: "+264" },
  { label: "瑙鲁", label_en: "Nauru", value: "+674" },
  { label: "尼泊尔", label_en: "Nepal", value: "+977" },
  { label: "荷兰", label_en: "Netherlands", value: "+31" },
  { label: "新西兰", label_en: "New Zealand", value: "+64" },
  { label: "尼加拉瓜", label_en: "Nicaragua", value: "+505" },
  { label: "尼日尔", label_en: "Niger", value: "+227" },
  { label: "尼日利亚", label_en: "Nigeria", value: "+234" },
  { label: "朝鲜", label_en: "North Korea", value: "+850" },
  { label: "北马其顿", label_en: "North Macedonia", value: "+389" },
  { label: "挪威", label_en: "Norway", value: "+47" },
  { label: "阿曼", label_en: "Oman", value: "+968" },
  { label: "巴基斯坦", label_en: "Pakistan", value: "+92" },
  { label: "帕劳", label_en: "Palau", value: "+680" },
  { label: "巴拿马", label_en: "Panama", value: "+507" },
  {
    label: "巴布亚新几内亚",
    label_en: "Papua New Guinea",
    value: "+675",
  },
  { label: "巴拉圭", label_en: "Paraguay", value: "+595" },
  { label: "秘鲁", label_en: "Peru", value: "+51" },
  { label: "菲律宾", label_en: "Philippines", value: "+63" },
  { label: "波兰", label_en: "Poland", value: "+48" },
  { label: "葡萄牙", label_en: "Portugal", value: "+351" },
  { label: "卡塔尔", label_en: "Qatar", value: "+974" },
  { label: "罗马尼亚", label_en: "Romania", value: "+40" },
  { label: "卢旺达", label_en: "Rwanda", value: "+250" },
  {
    label: "圣基茨和尼维斯",
    label_en: "Saint Kitts and Nevis",
    value: "+1869",
  },
  { label: "圣卢西亚", label_en: "Saint Lucia", value: "+1758" },
  {
    label: "圣文森特和格林纳丁斯",
    label_en: "Saint Vincent and the Grenadines",
    value: "+1784",
  },
  { label: "萨摩亚", label_en: "Samoa", value: "+685" },
  { label: "圣马力诺", label_en: "San Marino", value: "+378" },
  {
    label: "圣多美和普林西比",
    label_en: "Sao Tome and Principe",
    value: "+239",
  },
  { label: "塞内加尔", label_en: "Senegal", value: "+221" },
  { label: "塞尔维亚", label_en: "Serbia", value: "+381" },
  { label: "塞舌尔", label_en: "Seychelles", value: "+248" },
  { label: "塞拉利昂", label_en: "Sierra Leone", value: "+232" },
  { label: "斯洛伐克", label_en: "Slovakia", value: "+421" },
  { label: "斯洛文尼亚", label_en: "Slovenia", value: "+386" },
  { label: "所罗门群岛", label_en: "Solomon Islands", value: "+677" },
  { label: "索马里", label_en: "Somalia", value: "+252" },
  { label: "西班牙", label_en: "Spain", value: "+34" },
  { label: "斯里兰卡", label_en: "Sri Lanka", value: "+94" },
  { label: "苏丹", label_en: "Sudan", value: "+249" },
  { label: "苏里南", label_en: "Suriname", value: "+597" },
  { label: "斯威士兰", label_en: "Swaziland", value: "+268" },
  { label: "瑞典", label_en: "Sweden", value: "+46" },
  { label: "瑞士", label_en: "Switzerland", value: "+41" },
  { label: "叙利亚", label_en: "Syria", value: "+963" },
  { label: "塔吉克斯坦", label_en: "Tajikistan", value: "+992" },
  { label: "坦桑尼亚", label_en: "Tanzania", value: "+255" },
  { label: "泰国", label_en: "Thailand", value: "+66" },
  { label: "东帝汶", label_en: "Timor-Leste", value: "+670" },
  { label: "多哥", label_en: "Togo", value: "+228" },
  { label: "汤加", label_en: "Tonga", value: "+676" },
  {
    label: "特立尼达和多巴哥",
    label_en: "Trinidad and Tobago",
    value: "+1868",
  },
  { label: "突尼斯", label_en: "Tunisia", value: "+216" },
  { label: "土库曼斯坦", label_en: "Turkmenistan", value: "+993" },
  { label: "图瓦卢", label_en: "Tuvalu", value: "+688" },
  { label: "乌干达", label_en: "Uganda", value: "+256" },
  { label: "乌克兰", label_en: "Ukraine", value: "+380" },
  { label: "乌拉圭", label_en: "Uruguay", value: "+598" },
  { label: "乌兹别克斯坦", label_en: "Uzbekistan", value: "+998" },
  { label: "瓦努阿图", label_en: "Vanuatu", value: "+678" },
  { label: "梵蒂冈", label_en: "Vatican City", value: "+379" },
  { label: "委内瑞拉", label_en: "Venezuela", value: "+58" },
  { label: "也门", label_en: "Yemen", value: "+967" },
  { label: "赞比亚", label_en: "Zambia", value: "+260" },
  { label: "津巴布韦", label_en: "Zimbabwe", value: "+263" },
  { label: "科索沃", label_en: "Kosovo", value: "+383" },
  { label: "库拉索", label_en: "Curaçao", value: "+599" },
  {
    label: "法属波利尼西亚",
    label_en: "French Polynesia",
    value: "+689",
  },
  { label: "新喀里多尼亚", label_en: "New Caledonia", value: "+687" },
  { label: "关岛", label_en: "Guam", value: "+1671" },
  { label: "波多黎各", label_en: "Puerto Rico", value: "+1787" },
  { label: "美属萨摩亚", label_en: "American Samoa", value: "+1684" },
  { label: "格陵兰", label_en: "Greenland", value: "+299" },
  { label: "法属圭亚那", label_en: "French Guiana", value: "+594" },
  { label: "马提尼克", label_en: "Martinique", value: "+596" },
  { label: "留尼汪", label_en: "Réunion", value: "+262" },
];

CountryCodes.sort((a, b) => {
  if (!a.label_en) return 1;
  if (!b.label_en) return -1;
  return a.label_en.localeCompare(b.label_en);
});

export default CountryCodes;
